import React, { useMemo, useState } from "react";
import { ChevronDown, ChevronRight, ShieldAlert, Pencil } from "lucide-react";
import { tcError } from "@/lib/tc";

export const InvalidTcPanel = ({ list, onEdit }) => {
  const [open, setOpen] = useState(false);
  const bad = useMemo(() => (list || []).filter((p) => p.aktif !== false)
    .map((p) => ({ p, err: tcError(p.sicil_no) })).filter((x) => x.err), [list]);
  if (!bad.length) return null;
  return (
    <div className="mx-4 md:mx-5 mt-3 border border-rose-300 bg-rose-50 rounded-lg" data-testid="invalid-tc-panel">
      <button type="button" onClick={() => setOpen(!open)} data-testid="invalid-tc-toggle"
        className="w-full flex items-center gap-2 px-3 py-2 text-left text-sm font-semibold text-rose-900">
        <ShieldAlert size={15} className="text-rose-600" />
        <span data-testid="invalid-tc-count">{bad.length} aktif personelin TC Kimlik No'su geçersiz görünüyor</span>
        <span className="ml-auto">{open ? <ChevronDown size={15} /> : <ChevronRight size={15} />}</span>
      </button>
      {open && (
        <div className="px-3 pb-3 space-y-1.5">
          {bad.map(({ p, err }) => (
            <div key={p.id} className="flex items-center gap-3 bg-white border border-rose-200 rounded-md px-2 py-1.5" data-testid={`invalid-tc-row-${p.id}`}>
              <div className="flex-1 min-w-0">
                <div className="text-sm font-semibold text-slate-900">{p.ad_soyad}</div>
                <div className="text-[11px] text-slate-500">{p.pozisyon}</div>
              </div>
              <span className="font-mono text-xs text-slate-700">{p.sicil_no}</span>
              <span className="text-[11px] text-rose-700 font-semibold w-48">{err}</span>
              <button onClick={() => onEdit(p)} data-testid={`invalid-tc-edit-${p.id}`}
                className="inline-flex items-center gap-1 px-2.5 py-1 bg-slate-900 text-white rounded text-xs font-semibold">
                <Pencil size={12} /> Düzelt
              </button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};
